import { useState } from "react";
import TableComponent from "./TableComponent";
import { Card, CardContent, CardHeader } from "./ui";

type Props = {
  list: LeadUserCartDesign[];
  name: string;
  totalQunty: number;
  totalwight: number;
};

const AccordionComponent = ({ list, name, totalQunty, totalwight }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <Card className="overflow-hidden">
      <CardHeader className="bg-white p-4 cursor-pointer border-b" onClick={() => setIsOpen((prev) => !prev)}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-bold text-gray-900 uppercase tracking-wide">{name}</h3>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-sm text-gray-600 font-medium">
              {totalQunty} pcs | {totalwight} gms
            </div>
            <svg 
              className={`w-5 h-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </CardHeader>
      
      {isOpen && (
        <CardContent className="p-0">
          <TableComponent 
            list={list} 
            name={name} 
            totalQunty={totalQunty} 
            totalwight={totalwight}
          />
        </CardContent>
      )}
    </Card>
  );
};

export default AccordionComponent;